import { render, staticRenderFns } from "./HealthInfoDeatil.vue?vue&type=template&id=0379b922&"
import script from "./HealthInfoDeatil.vue?vue&type=script&lang=js&"
export * from "./HealthInfoDeatil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports